export type RouteDefinition = {
    PATH: string;
    NAME: string;
}

export const ROUTE = {
    INITIAL_ROUTE: {
        PATH: "/",
        NAME: "InitialRoute"
    },
    RESTRICTED_AREA: {
        PATH: "/r",
        NAME: "RestrictedArea"
    },
    PRODUCT_SEARCH: {
        PATH: "/product-search",
        NAME: "ProductSearch"
    },
    PRODUCT_DETAIL: {
        PATH: "/product-detail/:productId",
        NAME: "ProductDetail",
    },
    OUTBOX: {
        PATH: "/outbox",
        NAME: "Outbox"
    },
    CUSTOMER_SEARCH: {
        PATH: "/customer-search",
        NAME: "CustomerSearch"
    },
    CUSTOMER_DETAIL: {
        PATH: "/customer-detail/:customerId",
        NAME: "CustomerDetail"
    },
    ERROR_PAGE: {
        PATH: "/error-page",
        NAME: "ErrorPage"
    },
    ERROR_NOT_FOUND: {
        PATH: "/not-found",
        NAME: "NotFound"
    },
    MODULAR_QUALITY_STATEMENT_WIZARD: {
        PATH: "/modular-quality-statement-wizard/:productId",
        NAME: "ModularQualityStatementWizard"
    },
    DOCUMENT_CHECKOUT: {
        PATH: "/document-checkout",
        NAME: "DocumentCheckout"
    },
    DOCUMENT_CHECKOUT_CART_OVERVIEW: {
        PATH: "/document-checkout/cart",
        NAME: "DocumentCheckoutCartOverview"
    },
    DOCUMENT_CHECKOUT_CART_SUCCESS: {
        PATH: "/document-checkout/cart/success",
        NAME: "DocumentCheckoutCartSuccess"
    },
    DOCUMENT_CHECKOUT_CART_ERROR: {
        PATH: "/document-checkout/cart/error",
        NAME: "DocumentCheckoutCartError"
    },
    DOCUMENT_CHECKOUT_CART_CREATE_CUSTOMER: {
        PATH: "/document-checkout/create-customer",
        NAME: "DocumentCheckoutCartCreateCustomer"
    }
} as const;
